// Dependencies
import { useEffect, useRef, useCallback } from 'react'

export const useDebug = (componentName: string) => {
  // States & Refs
  const componentRenderCount = useRef(0)

  // Helper functions
  const logDebugMessage = (message: string) =>
    console.log(`[${new Date().toISOString()}] DEBUG: ${message}`)
  const logRenderCount = useCallback(() => {
    return logDebugMessage(
      `Component "${componentName}" has been rendered ${componentRenderCount.current}x.`,
    )
  }, [componentName, componentRenderCount])

  // Increment the "componentRenderCount" on every componenent's re-render
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return
    }
    componentRenderCount.current++
    logRenderCount()
  })

  return process.env.NODE_ENV === 'production'
    ? {
        logDebugMessage: () => {},
      }
    : {
        logDebugMessage,
      }
}
